import getCellIdentity from './getCellIdentity';
import { findNextFocusItemInForm } from './findNextFocusItemInForm';
import { checkboxInTable } from './handleSpecialCase';
import { keyByModuleId } from '../createKeyMap';
import { MODULE_TYPE } from '../config/moduleType';
import { config as CONFIG } from '@platform/api'

/**
 * @desc 查找下一个可聚焦元素
 * @param target {dom} 事件源
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 当前区域Id
 * @param orderOfHotKey {array} 区域显示顺序配置
 */
function findNextFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey }) {
    var parentTd = eventTarget.tagName === 'TD' ? eventTarget : findParentTd(eventTarget);
    if (!parentTd) {
        // 这里报错的原因是因为某些事件（下拉的keydown）执行了两次
        console.warn('not find parentTd, next hotkey invalid');
        return;
    }
    var nextTd = parentTd.nextElementSibling;
    var currentTr = parentTd.parentElement;
    var lastTd = findLastTdInRow(currentTr);
    var div = nextTd && nextTd.querySelector('[tabindex="0"]');

    //如果是最后一个元素就需要判断跳到下一行还是跳到下一个区域
    if (lastTd === parentTd) {
        var lastTr = currentTr.parentElement.lastElementChild;

        currentTr === lastTr
            ? perceptionHotKeyConfig({ currentModuleId: moduleId, ViewModel, orderOfHotKey })
            : findNextRowTd({ tr: currentTr, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    // 如果下一个元素没有找到就继续查找
    if (div === null || checkboxInTable(div)) {
        findNextSiblings({ td: nextTd, ViewModel, moduleId, orderOfHotKey });
        return;
    }
    // 解决table 设值后重新渲染导致焦点缺失的问题,在这里保留一下id
    let cellIdentity = getCellIdentity(nextTd);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';
    executeAutoFocus({ div, ViewModel });
}

function findParentTd(el) {
    while (el.parentElement) {
        el = el.parentElement;
        if (el.tagName === 'TD') {
            return el;
        }
    }
    return null;
}

/**
 * @desc 查找当前行里的最后一个td，需要排除操作列
 * @param tr {dom}
 * @return td {dom}
 */
function findLastTdInRow(tr) {
    let td = tr.lastElementChild.className.includes('fixed')
        ? tr.lastElementChild.previousElementSibling
        : tr.lastElementChild;

    return td;
}

/**
 * @desc 递归查找下一个可聚焦元素
 * @param td {dom} 上一个td
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 当前区域的Id
 * @param orderOfHotKey
 */
function findNextSiblings({ td, ViewModel, moduleId, orderOfHotKey }) {
    var nextTd = td.nextElementSibling;
    var currentTr = nextTd && nextTd.parentElement;
    var lastTd = currentTr && findLastTdInRow(currentTr);
    var currentDiv = td.querySelector('[tabindex="0"]');
    var div = nextTd && nextTd.querySelector('[tabindex="0"]');

    //如果下个需要聚焦的单元格与最后一个单元相同并且没有可聚焦元素就在下一行查找
    if ((lastTd === nextTd && div === null) || (lastTd === td && currentDiv === null)) {
        findNextRowTd({ tr: currentTr, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    if (div === null || checkboxInTable(div)) {
        findNextSiblings({ td: nextTd, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    let cellIdentity = getCellIdentity(nextTd);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';
    executeAutoFocus({ div, ViewModel });
}

//查找下一行可聚焦元素
function findNextRowTd({ tr, ViewModel, moduleId, orderOfHotKey }) {
    var nextTr = tr && tr.nextElementSibling;

    //如果是最后一行就查找下个区域的第一个可聚焦元素
    if (nextTr === null) {
        orderOfHotKey &&
            jumpToNextModuleFocusItem({ currentModuleId: moduleId, ViewModel, orderOfHotKey });
        return;
    }

    if (nextTr.getAttribute('tabindex') === '-1') {
        findNextRowTd({ tr: nextTr, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    var div = nextTr.querySelector('td [tabindex="0"]');
    var td = findParentTd(div);

    let cellIdentity = getCellIdentity(td);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';
    executeAutoFocus({ div, ViewModel });
}

/**
 * @desc 判断业务组是否配置快捷键，如果没有就在本区域内循环 反之根据orderOfHotKey跳转下个区域
 * @param currentModuleId {string} 当前的区域ID
 * @param ViewModel 全局变量
 * @param orderOfHotKey {array} 区域展示顺序
 */

function perceptionHotKeyConfig({ currentModuleId, ViewModel, orderOfHotKey }) {
    if (orderOfHotKey && orderOfHotKey.length === 0) {
        findFirstFocusItemInCurrentModule({ currentModuleId, ViewModel });
    } else {
        orderOfHotKey &&
            jumpToNextModuleFocusItem({ currentModuleId, ViewModel, orderOfHotKey });
    }
}

function findFirstFocusItemInCurrentModule({ currentModuleId, ViewModel }) {
    let id = `${CONFIG.hotKeyModuleIdPrefix}-${currentModuleId}`;
    let tableTr = document.querySelector(`#${id} table tbody tr`);
    let tds = tableTr.querySelectorAll('td');

    let firstFocusItem = Array.prototype.find.call(tds, function (td) {
        return td.querySelector('[tabindex="0"]') !== null;
    });

    let cellIdentity = getCellIdentity(firstFocusItem);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';

    var div = firstFocusItem.querySelector('[tabindex="0"]');
    div && executeAutoFocus({ div, ViewModel });
}

function jumpToNextModuleFocusItem({ currentModuleId, ViewModel, orderOfHotKey }) {
    let nextModuleId = calculateNextModuleId(currentModuleId, orderOfHotKey);

    let nextModuleKeyMap = keyByModuleId[nextModuleId];

    if (nextModuleKeyMap === undefined) return;

    let type = nextModuleKeyMap.type;
    if (type === MODULE_TYPE.cardTable || type === MODULE_TYPE.editTable) {
        //如果是table类型就获取当前table显示的页签
        let activeTableKeyMap = keyByModuleId[nextModuleKeyMap.activeTable];
        let firstItemDom = document.querySelector(`div[${activeTableKeyMap.firstItem}]`);
        let div = firstItemDom.querySelector('[tabindex="0"]');

        if (div === null) {
            let td = firstItemDom.parentElement;
            findNextSiblings({ td, ViewModel, moduleId: activeTableKeyMap.moduleId, orderOfHotKey });
        } else {
            let td = findParentTd(div);

            /**
       * @desc 表格编辑后会导致页面重新渲染导致聚焦状态丢失，因此enter键跳转的需要在全局记录一下，为操作的连续性渲染完成后重新聚焦做标识
       * @type {string}
       */
            let cellIdentity = getCellIdentity(td);
            cellIdentity
                ? ViewModel.enterTriggerCellId = cellIdentity
                : '';
            executeAutoFocus({ div, ViewModel });
        }

    } else {
        findNextFocusItemInForm(nextModuleKeyMap, nextModuleId);
    }
}

function calculateNextModuleId(currentModuleId, orderOfHotKey) {
    let orderOfHotKeyLen = orderOfHotKey.length;

    let nextModuleIndex = orderOfHotKey.indexOf(currentModuleId) + 1 === orderOfHotKeyLen
        ? 0
        : orderOfHotKey.indexOf(currentModuleId) + 1;
    return orderOfHotKey[nextModuleIndex];
}

function executeAutoFocus({ div, ViewModel }) {
    if (div !== null) {
        ViewModel.shouldAutoFocus = true;
        div.ncExecuteFocus = true;
        div.focus();
        delete div.ncExecuteFocus;
    }
}

export {
    findNextFocusItemInTable,
    executeAutoFocus,
};
